import { createFileRoute } from '@tanstack/react-router'
import { AgentsPage } from '../pages/agents'
import { agentsQueryOptions } from '../api'

export const Route = createFileRoute('/agents')({
  component: AgentsPageComponent,
  // Prefetch agents data without blocking route rendering
  loader: ({ context }) => {
    context.queryClient.prefetchQuery(agentsQueryOptions());
    return null;
  },
})

function AgentsPageComponent() {
  return <AgentsPage />
}
